import ElevationChart from './ElevationChart';
export default ElevationChart;
